import React from 'react';
import './StatsCard.scss';

interface StatsCardProps {
  title: string;
  value: number;
  onClick?: () => void;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  onClick
}) => {
  return (
    <div className="stats-card" onClick={onClick} role={onClick ? 'button' : undefined}>
      <div className="stats-card__top">
        <p className="stats-card__title">{title}</p>
      </div>
      <div className="stats-card__bottom">
        <p className="stats-card__value">{value}</p>
        {onClick && (
          <div className="stats-card__arrow">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
